import React, { useState, useEffect,useRef } from "react";
import { Modal, Button, Form, Image, Spinner, Alert} from "react-bootstrap";
import { FaTimes, FaPen } from "react-icons/fa";
import { AuthService } from "../Services/AuthService";
import { StorageUtils } from '../Utils/StorageUtils'; // Import the utility
import { useUserProfile } from "../contexts/UserProfileContext";


const EditProfileModal = ({ show, onHide, user }) => {
  const { refreshProfile } = useUserProfile();
  const [loading, setLoading] = useState(false); // Loader state
  const [apiResponse, setApiResponse] = useState(null);
  const [localUser, setLocalUser] = useState({
    name: "",
    email: "",
    image: "/assets/default_user.png",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });

    const fileInputRef = useRef();

    const [previewImage, setPreviewImage] = useState(localUser.image);
const [selectedImage, setSelectedImage] = useState(null);

  // Initialize localUser from props
  useEffect(() => {
    if (user) {
      setLocalUser({
        name: user.name || "",
        email: user.email || "",
        image: user.image || "/assets/default_user.png",
      });
      setPreviewImage(user.image || "/assets/default_user.png");
      setErrors({ name: "", email: "" }); // Reset errors when modal opens
    }
  }, [user, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalUser((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "", // clear error while typing
    }));
  };

  const validate = () => {
    let valid = true;
    let newErrors = {};

    if (!localUser.name.trim()) {
      newErrors.name = "Name is required.";
      valid = false;
    } else if (localUser.name.length < 2) {
      newErrors.name = "Name must be at least 2 characters.";
      valid = false;
    }

    if (!localUser.email.trim()) {
      newErrors.email = "Email is required.";
      valid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(localUser.email)) {
      newErrors.email = "Email is invalid.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSave = async () => {
    if (validate()) {
      try {
        setLoading(true); // Start loader
              const formData = new FormData();
              formData.append('name', localUser.name);
              formData.append('email', localUser.email);
              if (selectedImage) {
                formData.append('profile_image', selectedImage); // Append the file directly
              }

        const response = await AuthService.updateProfile(formData);

        const token = StorageUtils.getUserData()?.token;
        const data = {
        token: token,
        user: response.data.user,
      }

      console.log("TEMP Response from API:", data);



        StorageUtils.saveUserData(data);
        setApiResponse(response.data);

        console.log(response.data);
        
        // Refresh profile data in context (will update all components using the profile)
        await refreshProfile();
        
        window.dispatchEvent(new Event("storage"));
        
        setTimeout(() => {
            setApiResponse(null);
          onHide(); // Close modal after saving
          window.dispatchEvent(new Event('storage'));
        }, 1000);
      } catch (error) {
        setApiResponse(null);
        console.error("Error saving profile:", error);
        setApiResponse({
          error: error.response?.data?.message || "Failed to save profile",
        });
        // Handle error appropriately, e.g., show a toast or alert
        
      } finally {
        setApiResponse(null);
        setLoading(false); // Stop loader
      }
      console.log("Saving user:", localUser);
      // TODO: Send to API here
    }
  };

   const handleFileChange = async (event) => {
     const file = event.target.files[0];
  if (file) {
    setSelectedImage(file); // Store the selected file
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewImage(reader.result); // For preview
      setLocalUser((prev) => ({
        ...prev,
        image: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  }
  };


  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="p-4">
        <div className="d-flex justify-content-end">
          <FaTimes onClick={onHide} style={{ cursor: "pointer" }} />
        </div>

        <div className="d-flex align-items-center mb-4">
          <div className="position-relative me-3">
            <Image src={previewImage} roundedCircle width={80} height={80} style={{ objectFit: 'cover' }} />
            <div onClick={() => fileInputRef.current.click()}>
            <div
              className="position-absolute d-flex justify-content-center align-items-center"
              style={{
                bottom: 0,
                right: 0,
                width: "24px",
                height: "24px",
                backgroundColor: "#fff",
                borderRadius: "50%",
                border: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              <FaPen size={12} />
            </div>
            </div>
               {/* Hidden file input */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
    
          </div>

          <div>
            <h5 style={{ fontWeight: "400", fontSize: "16px" }}>
              {localUser.name}
            </h5>
            <p className="text-muted mb-0">{localUser.email}</p>
          </div>
        </div>

        <Form>
          <Form.Group className="py-2 border-bottom">
            <div className="d-flex align-items-center">
              <Form.Label className="mb-0 me-3" style={{ width: "120px" }}>
                Name
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={localUser.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className="ms-auto"
                style={{
                  textAlign: "right",
                  border: "none",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  paddingRight: "12px",
                  width: "auto",
                  flex: "1",
                }}
              />
            </div>
            {errors.name && (
              <div className="text-danger small text-end mt-1">
                {errors.name}
              </div>
            )}
          </Form.Group>

          <Form.Group className="py-2 border-bottom">
            <div className="d-flex align-items-center">
              <Form.Label className="mb-0 me-3" style={{ width: "120px" }}>
                Email account
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={localUser.email}
                onChange={handleChange}
                placeholder="Enter your email"
                className="ms-auto"
                style={{
                  textAlign: "right",
                  border: "none",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  paddingRight: "12px",
                  width: "auto",
                  flex: "1",
                }}
              />
            </div>
            {errors.email && (
              <div className="text-danger small text-end mt-1">
                {errors.email}
              </div>
            )}
          </Form.Group>

          <div className="text-start mt-4">
            <Button variant="primary" onClick={handleSave}>
              
               {loading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        {' Please Wait...'}
                      </>
                    ) : (
                      'Save Changes'
                    )}
            </Button>
          </div>
          {apiResponse && (
                  <Alert variant={apiResponse.error ? 'danger' : 'success'} className="mt-3">
                    {apiResponse.error || 'Login successful!'}
                  </Alert>
                )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditProfileModal;
